import { BrandVerificationStatus } from 'lib/enums/BrandVerificationStatus';
import { ManufacturerVerificationStatus } from 'lib/enums/ManufacturerVerificationStatus';
// update along with app/lib/enums/dashboard_widget_types.py
const DashboardWidgetType = {
  VERIFIED_VENDOR_PRODUCTS: 'VERIFIED_VENDOR_PRODUCTS',
  VERIFIED_BRANDS: 'VERIFIED_BRANDS',
  VERIFIED_MANUFACTURERS: 'VERIFIED_MANUFACTURERS',
  TAGGED_IMAGES: 'TAGGED_IMAGES',
  CONTENT_VERIFIED_BRANDS: 'CONTENT_VERIFIED_BRANDS',
  VERIFICATION_PENDING_BRANDS: 'VERIFICATION_PENDING_BRANDS',
  UNVERIFIED_BRANDS: 'UNVERIFIED_BRANDS',
  UNVERIFIABLE_BRANDS: 'UNVERIFIABLE_BRANDS',
  VERIFICATION_PENDING_MANUFACTURERS: 'VERIFICATION_PENDING_MANUFACTURERS',
  UNVERIFIED_BRANDS_IN_DISTRIBUTOR_PARTNERS: 'UNVERIFIED_BRANDS_IN_DISTRIBUTOR_PARTNERS',
  UNCLASSIFIED_ACTIVE_DISTRIBUTOR_PARTNER_PRODUCTS:
    'UNCLASSIFIED_ACTIVE_DISTRIBUTOR_PARTNER_PRODUCTS',
  UNCLASSIFIED_VERIFIED_MFR_PRODUCTS: 'UNCLASSIFIED_VERIFIED_MFR_PRODUCTS',
  VERIFIED_SIMILAR_BRANDS: 'VERIFIED_SIMILAR_BRANDS',
  CONTENT_VERIFIED_MANUFACTURER_PRODUCTS: 'CONTENT_VERIFIED_MANUFACTURER_PRODUCTS',
  RESOLVED_BRANDS: 'RESOLVED_BRANDS',
  KNOWN_SKU_MANUFACTURER_PRODUCTS: 'KNOWN_SKU_MANUFACTURER_PRODUCTS',
  ENGAGED_MANUFACTURERS: 'ENGAGED_MANUFACTURERS',
  KNOWN_SKUS_ENRICHED_BY_MANUFACTURERS: 'KNOWN_SKUS_ENRICHED_BY_MANUFACTURERS',
  KNOWN_SKU_MANUFACTURER_PRODUCTS_WITH_SCORE_ABOVE_60:
    'KNOWN_SKU_MANUFACTURER_PRODUCTS_WITH_SCORE_ABOVE_60',
  ACTIVE_DP_PRODUCTS: 'ACTIVE_DP_PRODUCTS',
  ACTIVE_DP_PRODUCTS_SKU_MAPPED: 'ACTIVE_DP_PRODUCTS_SKU_MAPPED',
  SKU_MAPPED_DP_PRODUCTS: 'SKU_MAPPED_DP_PRODUCTS',
  DP_PRODUCTS_WITH_A_SALE_IN_3M: 'DP_PRODUCTS_WITH_A_SALE_IN_3M',
  DP_PRODUCTS_WITH_A_SALE_IN_3M_AND_MAPPED_TO_A_VERIFIED_SKU:
    'DP_PRODUCTS_WITH_A_SALE_IN_3M_AND_MAPPED_TO_A_VERIFIED_SKU',
  DP_PRODUCTS_WITH_A_SALE_IN_3M_AND_MAPPED_TO_A_KNOWN_SKU:
    'DP_PRODUCTS_WITH_A_SALE_IN_3M_AND_MAPPED_TO_A_KNOWN_SKU',
  OUTLIER_CLEANUP_PENDING: 'OUTLIER_CLEANUP_PENDING',
  OUTLIER_CLEANUP_SENT_FOR_DETECTION: 'OUTLIER_CLEANUP_SENT_FOR_DETECTION',
  OUTLIER_CLEANUP_CLEANED: 'OUTLIER_CLEANUP_CLEANED',
};

const DashboardWidgetTypeLabels = {
  [DashboardWidgetType.VERIFIED_VENDOR_PRODUCTS]: 'Verified Vendor Products',
  [DashboardWidgetType.VERIFIED_BRANDS]: 'Verified Brands',
  [DashboardWidgetType.VERIFIED_MANUFACTURERS]: 'Verified Manufacturers',
  [DashboardWidgetType.TAGGED_IMAGES]: 'Tagged Images',
  [DashboardWidgetType.CONTENT_VERIFIED_BRANDS]: 'Content Verified Brands',
  [DashboardWidgetType.VERIFICATION_PENDING_BRANDS]: 'Verification Pending Brands',
  [DashboardWidgetType.UNVERIFIED_BRANDS]: 'Unverified Brands',
  [DashboardWidgetType.UNVERIFIABLE_BRANDS]: 'Unverifiable Brands',
  [DashboardWidgetType.VERIFICATION_PENDING_MANUFACTURERS]: 'Verification Pending Manufacturers',
  [DashboardWidgetType.UNVERIFIED_BRANDS_IN_DISTRIBUTOR_PARTNERS]:
    'Unverified Brands Among Distributor Partners',
  [DashboardWidgetType.UNCLASSIFIED_ACTIVE_DISTRIBUTOR_PARTNER_PRODUCTS]:
    'Unclassified Active DP Products',
  [DashboardWidgetType.UNCLASSIFIED_VERIFIED_MFR_PRODUCTS]:
    'Unclassified Verified Manufacturer Products',
  [DashboardWidgetType.VERIFIED_SIMILAR_BRANDS]: 'Verified Similar Brands',
  [DashboardWidgetType.CONTENT_VERIFIED_MANUFACTURER_PRODUCTS]:
    'Content Verified Manufacturer Products',
  [DashboardWidgetType.RESOLVED_BRANDS]: 'Resolved Brands',
  [DashboardWidgetType.KNOWN_SKU_MANUFACTURER_PRODUCTS]: 'Known SKU Manufacturer Products',
  [DashboardWidgetType.ENGAGED_MANUFACTURERS]: 'Engaged Manufacturers',
  [DashboardWidgetType.KNOWN_SKUS_ENRICHED_BY_MANUFACTURERS]:
    'Known SKUs Enriched by Manufacturers',
  [DashboardWidgetType.KNOWN_SKU_MANUFACTURER_PRODUCTS_WITH_SCORE_ABOVE_60]:
    'Known SKU Manufacturer Products with Score Above 60',
  [DashboardWidgetType.ACTIVE_DP_PRODUCTS]: 'Active DP Products',
  [DashboardWidgetType.ACTIVE_DP_PRODUCTS_SKU_MAPPED]: 'Active DP Products SKU Mapped',
  [DashboardWidgetType.SKU_MAPPED_DP_PRODUCTS]: 'SKU Mapped DP Products',
  [DashboardWidgetType.DP_PRODUCTS_WITH_A_SALE_IN_3M]: 'DP Products with a sale in 3M',
  [DashboardWidgetType.DP_PRODUCTS_WITH_A_SALE_IN_3M_AND_MAPPED_TO_A_VERIFIED_SKU]:
    'DP Products with a sale in 3M and mapped to a verified SKU',
  [DashboardWidgetType.DP_PRODUCTS_WITH_A_SALE_IN_3M_AND_MAPPED_TO_A_KNOWN_SKU]:
    'DP Products with a sale in 3M and mapped to a known SKU',
  [DashboardWidgetType.OUTLIER_CLEANUP_PENDING]: 'Outlier Cleanup Pending',
  [DashboardWidgetType.OUTLIER_CLEANUP_SENT_FOR_DETECTION]: 'Outlier Cleanup Sent for Detection',
  [DashboardWidgetType.OUTLIER_CLEANUP_CLEANED]: 'Outlier Cleanup Cleaned',
};

// Tooltips for the dashboard widgets
const DashboardWidgetTypeTooltips = {
  [DashboardWidgetType.VERIFIED_VENDOR_PRODUCTS]:
    'Products from vendor catalogs that have been verified.',
  [DashboardWidgetType.VERIFIED_BRANDS]: 'Brands that have been successfully verified.',
  [DashboardWidgetType.VERIFIED_MANUFACTURERS]:
    'Manufacturers that have been successfully verified.',
  [DashboardWidgetType.TAGGED_IMAGES]: 'Product images that have been tagged with an attribute.',
  [DashboardWidgetType.CONTENT_VERIFIED_BRANDS]:
    'Brands whose product content has been reviewed and verified.',
  [DashboardWidgetType.VERIFICATION_PENDING_BRANDS]:
    'Brands that are awaiting verification review.',
  [DashboardWidgetType.UNVERIFIED_BRANDS]: 'Brands that have not been verified yet.',
  [DashboardWidgetType.UNVERIFIABLE_BRANDS]:
    'Brands that have been reviewed and marked as impossible to verify.',
  [DashboardWidgetType.VERIFICATION_PENDING_MANUFACTURERS]:
    'Manufacturers that are awaiting verification review.',
  [DashboardWidgetType.UNVERIFIED_BRANDS_IN_DISTRIBUTOR_PARTNERS]:
    'Brands associated with distributor partners that have not yet been verified.',
  [DashboardWidgetType.UNCLASSIFIED_ACTIVE_DISTRIBUTOR_PARTNER_PRODUCTS]:
    'Active distributor partner products that have not been assigned a classification.',
  [DashboardWidgetType.UNCLASSIFIED_VERIFIED_MFR_PRODUCTS]:
    'Products from verified manufacturers that have not been assigned a classification.',
  [DashboardWidgetType.VERIFIED_SIMILAR_BRANDS]:
    'Similar brand entries that have been verified and resolved.',
  [DashboardWidgetType.CONTENT_VERIFIED_MANUFACTURER_PRODUCTS]:
    'Manufacturer products whose content has been reviewed and verified.',
  [DashboardWidgetType.RESOLVED_BRANDS]:
    'Brands that have been resolved (e.g. merged or mapped to canonical entries).',
  [DashboardWidgetType.KNOWN_SKU_MANUFACTURER_PRODUCTS]:
    'Manufacturer products associated with a known SKU.',
  [DashboardWidgetType.ENGAGED_MANUFACTURERS]:
    'Manufacturers who are actively participating in the enrichment process.',
  [DashboardWidgetType.KNOWN_SKUS_ENRICHED_BY_MANUFACTURERS]:
    'Known SKUs that have been enriched with data provided by manufacturers.',
  [DashboardWidgetType.KNOWN_SKU_MANUFACTURER_PRODUCTS_WITH_SCORE_ABOVE_60]:
    'Known SKU manufacturer products with a data quality score above 60.',
  [DashboardWidgetType.ACTIVE_DP_PRODUCTS]:
    'Products from distributor partners that are currently active.',
  [DashboardWidgetType.ACTIVE_DP_PRODUCTS_SKU_MAPPED]:
    'Active distributor partner products that have been mapped to a SKU.',
  [DashboardWidgetType.SKU_MAPPED_DP_PRODUCTS]:
    'Distributor partner products that have been mapped to a known SKU.',
  [DashboardWidgetType.DP_PRODUCTS_WITH_A_SALE_IN_3M]: 'All the DP products with a sale in 3M.',
  [DashboardWidgetType.DP_PRODUCTS_WITH_A_SALE_IN_3M_AND_MAPPED_TO_A_VERIFIED_SKU]:
    'Excluding products without a brand and packer brands.',
  [DashboardWidgetType.DP_PRODUCTS_WITH_A_SALE_IN_3M_AND_MAPPED_TO_A_KNOWN_SKU]:
    'Excluding products without a brand and packer brands.',
  [DashboardWidgetType.OUTLIER_CLEANUP_PENDING]:
    'Brands with outliers identified but not yet sent to the ML server.',
  [DashboardWidgetType.OUTLIER_CLEANUP_SENT_FOR_DETECTION]:
    'Brands whose products have been exported to the ML server, awaiting outlier results.',
  [DashboardWidgetType.OUTLIER_CLEANUP_CLEANED]:
    'Brands whose outlier results have been imported and flagged products removed.',
};

const handleVerificationPendingBrandsClick = () => {
  const url =
    `/enrich-products/manage-brands` +
    `?verificationStatus=${BrandVerificationStatus.PENDING_VERIFICATION}`;
  window.open(url, '_blank');
};

const handleUnverifiedBrandsClick = () => {
  const url =
    `/enrich-products/manage-brands` +
    `?verificationStatus=${BrandVerificationStatus.UNVERIFIED}&isDPOnly=true`;
  window.open(url, '_blank');
};

const handleAllUnverifiedBrandsClick = () => {
  const url =
    `/enrich-products/manage-brands` + `?verificationStatus=${BrandVerificationStatus.UNVERIFIED}`;
  window.open(url, '_blank');
};

const handleUnverifiableBrandsClick = () => {
  const url =
    `/enrich-products/manage-brands` +
    `?verificationStatus=${BrandVerificationStatus.UNVERIFIABLE}`;
  window.open(url, '_blank');
};

const handleVerificationPendingManufacturersClick = () => {
  const url =
    `/enrich-products/manage-manufacturers` +
    `?verificationStatus=${ManufacturerVerificationStatus.PENDING_VERIFICATION}`;
  window.open(url, '_blank');
};

const WidgetClickHandlers = {
  [DashboardWidgetType.VERIFICATION_PENDING_BRANDS]: handleVerificationPendingBrandsClick,
  [DashboardWidgetType.VERIFICATION_PENDING_MANUFACTURERS]:
    handleVerificationPendingManufacturersClick,
  [DashboardWidgetType.UNVERIFIED_BRANDS_IN_DISTRIBUTOR_PARTNERS]: handleUnverifiedBrandsClick,
  [DashboardWidgetType.UNVERIFIED_BRANDS]: handleAllUnverifiedBrandsClick,
  [DashboardWidgetType.UNVERIFIABLE_BRANDS]: handleUnverifiableBrandsClick,
};

export { DashboardWidgetTypeLabels, DashboardWidgetTypeTooltips, WidgetClickHandlers };
export default DashboardWidgetType;
